
import Button from "../../../../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/Button";
import ContentTypes from "../../../../../../../../shared/lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import AppModel from "../../../../../../../../shared/src/ranj/app/core/AppModel";
import { AbstractDialogPlayerOptionsMediator } from "../AbstractDialogPlayerOptionsMediator";
import Array from "../../../../../../../../shared/lib/html5-software-library/src/ranj/util/Array";

/**
* DialogPlayerOptionsFixedButtonsMediator.js
* 
* Created on 8-okt-2013, 15:34:40
*
* @author Ivo Swartjes for Ranj
**/
export default class IntrospectionOptionsMediator extends AbstractDialogPlayerOptionsMediator {
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);

        this._speedFactor = AppModel.speedFactor;
        this._optionButtonDict = {};
        /** @type {Array<Button>} */
        this._buttonArray = [];

        this._handleOptionButtonClickedBound = this._handleOptionButtonClicked.bind(this);
    }

    initialize() {
        this._target.gotoAndStop(0);

        this._initForAnimation(this._target.bubbles);

        for (let i = 1; i <= 9; i++) {
            const buttonSkin = this._target[`dialogOptionButton${i}`];
            if (!buttonSkin) {
                break;
            }
            const button = new Button(buttonSkin);
            this._initForAnimation(buttonSkin);
            this._buttonArray.push(button);
        }

        this._clearOptionButtons();
    }

    destroy() {
        this._optionButtonDict = {};
        this._buttonArray = [];
        super.destroy();
    }

    // ------------------------------------------
    // 			Dialog displaying
    // ------------------------------------------

    _handleOptionButtonClicked({ currentTarget }) {
        const option = this._optionButtonDict[currentTarget.skin.id];
        let delay = 0;
        const buttons = [... this._buttonArray].reverse();
        for(const button of buttons) {
            button.setEnabled(false);
            this._animateOptionButtonOut(button.skin, delay += 250);
        }
        this._animateOptionButtonOut(this._target.bubbles, delay);

        // Tell delegate that this option was chosen.
        setTimeout(() => {
            const dialogPlayer = this.getDialogPlayer();
            this.setDialogPlayer(null);
            dialogPlayer.optionChosen(option);
            this.hide();
        }, delay + 250);
    }

    _clearOptionButtons() {
        for (const button of this._buttonArray) {
            button.removeEventListener("click", this._handleOptionButtonClickedBound);
            button.skin.visible = false;
            delete this._optionButtonDict[button.skin.id];
        }
    }

    _handleDialogOptionsChanged() {
        this._processDialogOptions();
    }
    
    _handleDialogOptionChosen(option) {
        this.setDialogPlayer(null);
        this.hide();
    }

    _processDialogOptions() {
        // Clear & hide all dialog buttons
        this._clearOptionButtons();

        // Show relevant dialog buttons
        // NB: shallow copy of options
        const currentOptions = this.getDialogPlayer().getCurrentOptions().shuffled();
        currentOptions.reverse();

        if (currentOptions.length > this._buttonArray.length) {
            console.error(`Number of options (${currentOptions.length}) exceeds number of option buttons (${this._buttonArray.length}).`);
        }

        this._animateOptionButtonIn(this._target.bubbles, 0);
        let delay = 0;
        for (let i = 0; i < currentOptions.length; i++) {
            const option = currentOptions[i];
            const button = this._buttonArray[i];
            const content = option.getData()?.getData()?.content;
            this._optionButtonDict[button.skin.id] = option;

            if (!content) {
                continue;
            }
            let label;
            switch (content.getType()) {
                case ContentTypes.TYPE_TEXT:
                    label = content.getText();
                    break;
                case ContentTypes.TYPE_KEY_MOMENT_CHOICE:
                    label = content.getChoice();
                    break;
            }
            if (!label) {
                label = "<TEXT NOT FOUND>";
            }
            button.setCenteredLabel(label);
            button.setEnabled(true);
            // NB: ensure to not stack event listeners for click
            button.removeEventListener("click", this._handleOptionButtonClickedBound);
            button.addEventListener("click", this._handleOptionButtonClickedBound);
            this._animateOptionButtonIn(button.skin, delay += 250);
        }
    }

    _initForAnimation(target) {
        target.yOrig = target.y;
        target.scaleOrig = target.scaleY;
    }

    _animateOptionButtonIn(target, delay) {
        target.visible = true;
        target.alpha = 0;
        target.scaleX = target.scaleY = .1 * target.scaleOrig;
        createjs.Tween.get(target)
            .wait(delay / this._speedFactor)
            .to({ alpha: 1, scaleX: target.scaleOrig, scaleY: target.scaleOrig }, 250 / this._speedFactor, createjs.Ease.backOut);
    }

    _animateOptionButtonOut(target, delay) {
        const scale = .1 * target.scaleOrig;
        createjs.Tween.get(target)
            .wait(delay / this._speedFactor)
            .to({ alpha: 0, scaleX: scale, scaleY: scale }, 250 / this._speedFactor, createjs.Ease.quadOut)
            .to({ visible: false }, 0);
    }
}